<template
  ><div class="return-address">
    <div class="fragment">
      <VForm
        :name="name"
        :initialValues="initialValues"
        :fields="fields"
      ></VForm>
    </div>
    <div class="btn-wrapper">
      <VButton
        label="Continue"
        :disabled="!_isFormValid || isLoading"
        @click="onBtnClick()"
      ></VButton>
    </div></div
></template>

<script>
import Vue from "vue";
import VueTypes from "vue-types";
import { mapActions, mapGetters } from "vuex";

//components
import VForm from "@/components/VForm";
import { accountAddressFormFields } from "@/constants/forms";
import { required, maxLength } from "@/utils/validations";
import VButton from "@/components/VButton";

//mixins
import withFormUtils from "@/mixins/withFormUtils";
import withToasted from "@/mixins/withToasted";
import withDialogWindowsSequence from "@/mixins/withDialogWindowsSequence";
import { convertDataToApi, convertDataFromApi } from "@/utils/util";

export default Vue.component("SignUpReturnAddressForm", {
  components: { VForm, VButton },

  data() {
    return {
      name: "signUpReturnAddress",
      selectedCountry: "US",
      initialValues: {}
    };
  },

  mixins: [withFormUtils, withToasted, withDialogWindowsSequence],

  computed: {
    fields() {
      const allFields = [
        ...accountAddressFormFields.map(item => {
          item.layout = "full";
          return item;
        })
      ];

      return this.getSelectedCountry === "US"
        ? allFields
        : allFields.slice(0, 2);
    },

    _isFormValid() {
      return this.isFormValid(this.name);
    },

    getInitialCountryValue() {
      return typeof this.getSelectedCountry === "string"
        ? this.getSelectedCountry
        : "US";
    },

    getSelectedCountry() {
      return this.getValue("country");
    },

    ...mapGetters("account", ["isLoading", "identity"])
  },

  methods: {
    onBtnClick() {
      this.validateForm(this.name);
      if (this._isFormValid) {
        return this.updateAccount({
          patch: true,
          id: this.id,
          values: {
            company: this.formValues.company,
            address: convertDataToApi("addressOld", this.formValues)
          },
          cb: () => {
            localStorage.setItem(this.name, JSON.stringify(this.formValues));
            this.nextSequencePage();
          },
          onError: () =>
            this.errorToast("Form is valid but account cant be updated")
        });
      }
    },

    ...mapActions("account", ["updateAccount"])
  },

  created() {
    const { account } = this.identity;

    this.id = account.id;

    if (account) {
      this.initialValues = {
        company: account.company,
        ...account.address
      };

      if (!this.initialValues.country) {
        this.initialValues.country = "US";
      }
    }
  },

  watch: {
    getSelectedCountry(country) {
      this.selectedCountry = country;
      if (country !== "US") {
        this.unregisterFields({
          formName: this.name,
          fieldsNames: ["city", "state", "street", "unit", "zip"]
        });
      }
      if (country === "US") {
        this.registerFields({
          formName: this.name,
          fields: this.fields.slice(2)
        });
      }
    }
  }
});
</script>

<style lang="scss" scoped>
.return-address {
  height: 100%;
  display: grid;
  grid-template-rows: 1fr auto;
}
</style>
